import React from 'react'
import PropTypes from 'prop-types'

export const HealthCheckTable = ({ data }) => {
  return (
    <React.Fragment>
      <h1 className="me-page-title">Health Check Results</h1>
      {data.missing_items && data.missing_items.length > 0 && (
        <div className="card-myed">
          <h3>Missing Activities</h3>
          <p>The following activities are missing from the LMS when we expected them to be present.</p>
          <table className="table table-danger">
            <thead>
              <tr>
                <th scope="col">Activity Title</th>
                <th scope="col">Course Number</th>
                <th scope="col">Resource Link GUID</th>
                <th scope="col">Activity ID</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {data.missing_items.map((link, index) => (
                <tr key={link.guid || index} className="danger">
                  <td>
                    <i className="fas fa-fw mr-4 color_red icon_color_red fa-exclamation-triangle" /> {link.activity_name}
                  </td>
                  <td>{link.coursenum}</td>
                  <td>{link.resource_link_guid}</td>
                  <td>{link.activity_id}</td>
                  <td>
                    <button className="btn btn-default btn-myed btn-default-myed btn-sm-myed">
                      Fix Link
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {data.unknown_items && data.unknown_items.length > 0 && (
        <div className="card-myed">
          <h3 className="mt-4">Unknown Activities</h3>
          <p>The following activities are unknown to us. They are found in the LMS but not found in our system.</p>
          <table className="table table-striped">
            <thead>
              <tr>
                <th scope="col">Label</th>
                <th scope="col">ID</th>
                <th scope="col">Resource ID</th>
                <th scope="col">Resource Link ID</th>
              </tr>
            </thead>
            <tbody>
              {data.unknown_items.map((item, index) => (
                <tr key={item.id || index}>
                  <td>{item.label}</td>
                  <td>{item.id}</td>
                  <td>{item.resourceId}</td>
                  <td>{item.resourceLinkId}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {data.valid_items && data.valid_items.length > 0 && (
        <div className="card-myed">
          <h3 className="mt-4">Valid Activities</h3>
          <p>The following activities seem to be correctly configured in the LMS.</p>
          <table className="table table-danger">
            <thead>
              <tr>
                <th scope="col">Activity Title</th>
                <th scope="col">Course Number</th>
                <th scope="col">Resource Link GUID</th>
                <th scope="col">Activity ID</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {data.valid_items.map((link, index) => (
                <tr key={link.guid || index} className="success">
                  <td>
                    <i className="fas fa-fw mr-4 text-success fa-check-circle" /> {link.activity_name}
                  </td>
                  <td>{link.coursenum}</td>
                  <td>{link.resource_link_guid}</td>
                  <td>{link.activity_id}</td>
                  <td />
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </React.Fragment>
  )
}

HealthCheckTable.propTypes = {
  data: PropTypes.object.isRequired
}